package org.lennycodes.hldi.pages.admin

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.getDownloadURL
import org.lennycodes.hldi.backend.ref
import org.lennycodes.hldi.backend.uploadBytes
import org.lennycodes.hldi.components.ResourceCategories
import org.lennycodes.hldi.data.Admin
import org.lennycodes.hldi.data.Event
import org.lennycodes.hldi.data.Milestone
import org.lennycodes.hldi.data.UploadedImage
import org.w3c.files.File

fun Admin.toFirebaseData():dynamic {
    val data = js("{}")
    data.fullName = fullName
    data.email = email
    return  data
}
fun Milestone.toFirebaseData(): dynamic {
    val data = js("{}")

    data.id = id
    data.year = year
    data.description = description

    return data
}
fun Event.toFirebaseData(): dynamic {

    val data = js("{}")

    data.id = id
    data.title = title
    data.date = date
    data.location = location
    data.description = description
    data.registrationUrl = registrationUrl

    return data
}
fun currentYear(): Int {
    return js("new Date().getFullYear()") as Int
}
fun isValidEmail(email: String): Boolean {

    val emailRegex = Regex(
        "^[A-Za-z0-9.!#\$%&'*+/=?^_`{|}~-]+@" +
                "[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?" +
                "(?:\\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$"
    )

    return email.matches(emailRegex)
}
fun isValidPassword(password: String): Boolean {

    return password.length >= 8 &&
            password.any { it.isUpperCase() } &&
            password.any { it.isLowerCase() } &&
            password.any { it.isDigit() }

}

fun isValidYear(year: String): Boolean {

    val currentYear = js("new Date().getFullYear()") as Int

    val yearValue = year.toIntOrNull() ?: return false

    return year.matches(Regex("^\\d{4}$")) &&
            yearValue in 2015..currentYear
}
fun generateFirebaseId(length: Int = 20): String {
    val chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"

    return (1..length)
        .map {
            chars.random()
        }
        .joinToString("")
}
suspend fun uploadImage(
    file: File,
    imageId: String
): UploadedImage {

    val storagePath =
        "gallery/$imageId-${file.name}"


    val imageRef =
        ref(
            FirebaseService.storage,
            storagePath
        )


    uploadBytes(
        imageRef,
        file
    ).await()


    val downloadUrl =
        getDownloadURL(imageRef)
            .await()


    return UploadedImage(
        url = downloadUrl,
        storagePath = storagePath
    )

}
fun String.shortBio(
    limit: Int = 160
): String {

    return if(length > limit){
        substring(0, limit).trim() + "..."
    }
    else {
        this
    }

}
val resourceCategoryList = listOf(
    "Annual Reports",
    "Policies & Guidelines",
    "Project Reports",
    "Research & Publications",
    "Financial Reports",
    "Report"
)

fun categoryName(category: String): String {
    return resourceCategoryList.find { it == category } ?: ResourceCategories.REPORTS
}